<template>
  <div>
    <b-row>
      <b-col
        v-if="mode !== 'delete'"
        sm="12"
        md="6">
        <b-form-group :class="{'error-input' : $v.confirm_reason.title_start_date.$error}">
          <label class="form__label">Effective Start Date <span style="color:red">*</span> </label>
          <j-datepicker
            v-model="$v.confirm_reason.title_start_date.$model"
            :disabled-dates="disabledStartDate(confirm_reason.title_end_date)"
            :disabled="false"
            format="MMM dd, yyyy"
            placeholder="Jan 01, 2020"/>
        </b-form-group>
      </b-col>
      <b-col
        v-if="mode !== 'delete'"
        sm="12"
        md="6">
        <b-form-group :class="{'error-input' : $v.confirm_reason.title_end_date.$error}">
          <label class="form__label">Effective End Date</label>
          <j-datepicker
            v-model="$v.confirm_reason.title_end_date.$model"
            :disabled-dates="disabledEndDate(confirm_reason.title_start_date)"
            :disabled="false"
            format="MMM dd, yyyy"
            placeholder="Jan 01, 2020"/>
        </b-form-group>
      </b-col>
      <b-col
        v-if="mode === 'delete'"
        md="12">
        <h6 class="text-center">Are you sure want to delete this information?</h6>
      </b-col>
      <b-col cols="12">
        <b-form-group :class="{'error-input' : $v.confirm_reason.reasons.$error}">
          <label class="form__label">Reason <span style="color:red">*</span> </label>
          <j-textarea
            v-model="$v.confirm_reason.reasons.$model"
            placeholder="Write reason here"
          />
          <!-- <j-single-select
            v-model="$v.confirm_reason.reasons.$model"
            :options="list_reason"
            placeholder="Select reason"
            value-format="object"
            label="name" /> -->
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <div class="float-right m__t--20">
          <b-button
            class="btn grey"
            @click="closeModal">Cancel</b-button>
          <b-button
            v-if="mode==='delete'"
            class="btn red"
            @click="updateReasons">Yes</b-button>
          <b-button
            v-else
            class="btn blue"
            @click="updateReasons">Update</b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    mode: {
      type: String,
      default: 'delete',
    },
    employeeData: {
      type: Object,
      default: () => {},
    },
    positionData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      confirm_reason: {
        reasons: null,
        title_start_date: null,
        title_end_date: null,
      },
    };
  },
  computed: {
    ...mapState('jStoreEmployee', ['list_reason']),

  },
  methods: {
    ...mapActions('jStoreEmployee', ['updateWithReason']),

    disabledEndDate(startDate) {
      return {
        color: 'light-grey',
        ranges: [{
          from: new Date(1, 1, 1),
          to: Date.parse(startDate),
        }],
      };
    },
    disabledStartDate(endDate) {
      return {
        color: 'light-grey',
        ranges: [{
          from: Date.parse(endDate),
          to: new Date(200000, 1, 1),
        }],
      };
    },
    closeModal() {
      this.confirm_reason = {
        reasons: null,
        title_start_date: null,
        title_end_date: null,
      };
      this.$v.confirm_reason.$reset();
      this.$emit('close-modal', true);
    },
    async updateReasons() {
      this.$v.confirm_reason.$touch();
      if (!this.$v.confirm_reason.$error) {
        const { reasons, title_start_date, title_end_date } = this.confirm_reason;
        const { company_location, employment_type_id } = this.employeeData;

        const req = {
          // reasons: reasons.id,
          reasons,
          title_start_date: title_start_date ? this.$moment(title_start_date).format('YYYY-MM-DD') : title_start_date,
          title_end_date: title_end_date ? this.$moment(title_end_date).format('YYYY-MM-DD') : title_end_date,
          location_id: company_location || 0,
          employment_type_id: employment_type_id || 0,
        };
        // const res = await this.updateWithReason({ id: this.$route.params.id, req });
        await this.updateWithReason({ id: this.$route.params.id, req });
        // if (!res.error) {
        this.$emit('update-form', true);
        this.closeModal();
        // }
      }
    },
  },
  validations() {
    const validate = {
      confirm_reason: {
        reasons: {
          required,
        },
        title_start_date: {

        },
        title_end_date: {

        },
      },
    };
    if (this.mode !== 'delete') {
      validate.confirm_reason.title_start_date = { required };
    }
    return validate;
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user-employee/assignment/jModalConfirmWithReason.vue